var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPlacardDoudous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "340 180 574 820",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    color: "currentColor",
    stroke: "currentColor",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433 311C416 286 420 252 443 232C473 205 514 227 514 279C514 286 510 291 505 292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821 311C838 286 834 252 811 232C781 205 740 227 740 279C740 286 744 291 749 292"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M505 292H749C813 292 858 341 858 404V840C858 914 816 967 750 967H504C438 967 396 914 396 840V404C396 341 441 292 505 292Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 292V735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 842C410 914 486 929 539 849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857 842C844 914 768 929 715 849"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 599,
    r: 17,
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 599,
    r: 17,
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D30353",
    fill: "#D30353",
    d: "M627 735C596 686 539 687 510 724C468 778 516 849 579 910C607 937 623 955 627 967C631 955 647 937 675 910C738 849 786 778 744 724C715 687 658 686 627 735"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlacardDoudous);
export default __webpack_public_path__ + "static/media/logo-placard-doudous.9947c183a25d6f6432255c53cbb92802.svg";
export { ForwardRef as ReactComponent };